import { render, staticRenderFns } from "./AdminLegacyServiceLog.vue?vue&type=template&id=11c1ef94"
import script from "./AdminLegacyServiceLog.vue?vue&type=script&lang=js"
export * from "./AdminLegacyServiceLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports